"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useQueryZero_exports = {};
__export(useQueryZero_exports, {
  useQuery: () => useQuery
});
module.exports = __toCommonJS(useQueryZero_exports);
var import_react = require("react");
function useQuery(q) {
  var enable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  var queryImpl = q;
  var [snapshot, setSnapshot] = (0, import_react.useState)(void 0);
  var [, setView] = (0, import_react.useState)(void 0);
  (0, import_react.useLayoutEffect)(
    function() {
      if (enable) {
        var view = q.materialize();
        setView(view);
        var unsubscribe = view.addListener(function(snapshot2) {
          setSnapshot(structuredClone(snapshot2));
        });
        view.hydrate();
        return function() {
          unsubscribe();
          view.destroy();
        };
      }
      setSnapshot(queryImpl.singular ? void 0 : []);
      setView(void 0);
      return function() {
      };
    },
    //
    [
      JSON.stringify(enable ? q.ast : null)
    ]
  );
  return snapshot;
}
//# sourceMappingURL=useQueryZero.js.map
